<template>
<div v-show="isModalVisible">
<div class="modal-mask" @click="closeModal">
      <div class="modal-container" @click.stop>
      <!-- Modal Header -->
      <div class="modal-header">
        <slot name="header"></slot>
        <button type="button" class="close" data-dismiss="modal" @click="closeModal">&times;</button>
      </div>
      <!-- Modal body -->
      <div class="modal-body">
        <slot name="body"></slot>
      </div>
      <!-- Modal footer -->
      <div class="modal-footer">
        <slot name="footer"></slot>
      </div>
     </div>
</div>
</div>
</template>

<script>

import router from '../../router/index.js';

export default {
  props: ['isModalVisible'],
  methods: {
    closeModal() {
      this.$emit('close');
    }
  },
}
</script>

<style scoped>
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
}
.modal-container {
    width: 450px;
    height: 410px;
    overflow-y: none;
    margin: 40px auto 0;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
}
.modal-body {
    margin: 0px;
    padding: 10px 10px 0px 10px;
}
@media(max-width:560px) {
  .modal-container {
    width: 98%;
    padding: 20px 20px;
  }
  .modal-body {
      margin: 0px;
      padding: 0px;
  }
}

.modal-header .sub-heading {
  background-color: #FFF;
  color: #555;
}
.modal-header {
  padding: 5px;
  border: 0px;
}
.modal-header .close {
  margin: -1.5rem -2rem -1rem auto;
}
.modal-footer {
  border-top: none;
  padding: 0px 10px !important;
}
.btn-info, .btn-info:hover, .btn-info:focus {
  background-color: #C3C3C3 !important;
  border: 1px solid #CCC !important;
  color: #000;
}
input, textarea {
    border: 1px solid #ced4da;
}
.pathway_save_btn {
  padding: 0px 10px !important;
  text-transform: uppercase;
  font-size: 18px;
  font-weight: 400;
  width: 80px; height: 35px;
}
.input_label {
  font-weight: 900;
  padding: 0;
  font-size: 13px;
}
.submit_btn {
  color: #FFF; 
  border-radius: 15px;
  font-weight: 900;
  width: 150px;
}
.modal-title {
  font-size: 14px;
  font-weight: 900;
  color: #002F42;
  padding-left: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/manager/create-pathway-modal.vue